import { type ReactNode, useState } from 'react'
import { api } from '../lib/api'
import BigButton from './BigButton'
import Field from './Field'

const STORAGE_KEY = 'rommelmarkt:adminToken'

type Props = {
  children: (token: string, logout: () => void) => ReactNode
}

export default function PinGate({ children }: Props) {
  const [token, setToken] = useState<string | null>(() => localStorage.getItem(STORAGE_KEY))
  const [pin, setPin] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function logout() {
    const current = token
    localStorage.removeItem(STORAGE_KEY)
    setToken(null)
    setPin('')
    if (current) {
      // Best-effort server-side invalidate; ignore failures.
      void api('/api/admin/logout', {
        method: 'POST',
        headers: { Authorization: `Bearer ${current}` },
      })
    }
  }

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setBusy(true)
    setError(null)
    const result = await api<{ token: string }>('/api/admin/login', {
      method: 'POST',
      body: JSON.stringify({ pin }),
    })
    setBusy(false)
    if (!result.ok) {
      if (result.status === 429) setError('Te veel pogingen. Wacht een kwartiertje en probeer opnieuw.')
      else if (result.error === 'bad-pin') setError('Onjuiste pincode.')
      else setError('Aanmelden mislukt.')
      return
    }
    localStorage.setItem(STORAGE_KEY, result.data.token)
    setToken(result.data.token)
  }

  if (token) return <>{children(token, logout)}</>

  return (
    <div className="container-narrow py-10">
      <h1 className="font-display text-6xl tracking-display uppercase mb-2">Beheer</h1>
      <p className="text-muted mb-6">Geef je pincode om verder te gaan.</p>
      <form onSubmit={submit} className="card p-6 shadow-block">
        <Field label="Pincode" htmlFor="pin" error={error ?? undefined}>
          <input
            id="pin"
            className="input"
            type="password"
            inputMode="numeric"
            autoComplete="off"
            value={pin}
            onChange={(e) => setPin(e.target.value)}
            autoFocus
          />
        </Field>
        <BigButton type="submit" disabled={busy || pin.length < 4}>
          {busy ? 'Bezig…' : 'Aanmelden'}
        </BigButton>
      </form>
    </div>
  )
}
